import { Abi } from 'viem'
import { useAccount, useReadContract } from 'wagmi'

import { useValueTokens } from '@/contexts/VaultTokensContext'
import seaAVAX from '@/contracts/seaAVAX'

export const useGetAvaxLastRewardUpdate = () => {
  const { chain } = useAccount()
  const { currentToken } = useValueTokens()

  const { data, isLoading, refetch } = useReadContract({
    abi: seaAVAX as Abi,
    address: currentToken.tokenAddresses[1][chain?.id] as `0x${string}`,
    functionName: 'lastRewardUpdate',
  })

  return { data, isLoading, refetch }
}
